module.exports = __webpack_public_path__ + "static/media/logo-boite-immo@2x.d492d79d.png";